import moment from "moment-jalaali";
import "services/helpers";
import "services/updater";
import "services/connection";
import "assets/js/jquery-ui-1.10.2.custom.min";

moment.locale(app.lang.locale);

if ("production".equals(process.env.NODE_ENV)) {
  document.addEventListener("contextmenu", (e) => e.preventDefault(), false);
}
